var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCanadaFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0238 31.4041C21.0652 31.4079 24.0217 30.4121 26.4279 28.5733V7.00267C24.0198 5.1673 21.0646 4.17188 18.0238 4.17188C14.9829 4.17188 12.0277 5.1673 9.61963 7.00267V28.5733C12.0258 30.4121 14.9823 31.4079 18.0238 31.4041Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0012 32.0368C10.0556 32.0368 3.5918 25.648 3.5918 17.7945C3.5918 9.94105 10.0556 3.55469 18.0012 3.55469C25.9469 3.55469 32.4082 9.94105 32.4082 17.7945C32.4082 25.648 25.9463 32.0368 18.0012 32.0368ZM18.0012 4.80522C10.7546 4.80522 4.85946 10.632 4.85946 17.7945C4.85946 24.9571 10.7546 30.7838 18.0012 30.7838C25.2479 30.7838 31.143 24.9571 31.143 17.7945C31.143 10.632 25.2466 4.80522 18.0012 4.80522Z",
    fill: "url(#paint0_linear_589_5199)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24805 17.7931C4.24662 19.8776 4.7303 21.9344 5.66166 23.8046C6.59302 25.6748 7.94712 27.3082 9.61922 28.5784V7.00781C7.94712 8.27807 6.59302 9.91144 5.66166 11.7816C4.7303 13.6518 4.24662 15.7086 4.24805 17.7931Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.799 17.7931C31.8003 15.7086 31.3165 13.6517 30.3851 11.7816C29.4536 9.91139 28.0994 8.27804 26.4272 7.00781V28.5784C28.0994 27.3082 29.4536 25.6748 30.3851 23.8047C31.3165 21.9345 31.8003 19.8776 31.799 17.7931Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8778 13.0421L20.12 16.9818C20.1088 17.0401 20.1173 17.1005 20.1442 17.1536C20.1711 17.2067 20.2149 17.2496 20.2688 17.2757C20.3228 17.3019 20.3839 17.3097 20.4429 17.2982C20.5018 17.2866 20.5552 17.2562 20.595 17.2117L22.1253 15.4971L22.5537 16.4415C22.5795 16.4976 22.6239 16.5433 22.6796 16.571C22.7353 16.5986 22.7989 16.6065 22.8598 16.5934L24.8479 16.1536L24.1507 18.3188C24.1282 18.3887 24.1333 18.4643 24.1651 18.5305C24.197 18.5967 24.2531 18.6484 24.3221 18.6752L25.0401 18.9553L21.534 21.8169C21.4784 21.8625 21.4389 21.9242 21.4208 21.9933C21.4028 22.0624 21.4073 22.1353 21.4336 22.2017L21.8492 23.2453L18.6559 22.7075C18.5957 22.6974 18.534 22.7009 18.4753 22.7176C18.4166 22.7343 18.3625 22.7639 18.317 22.8041C18.2715 22.8443 18.2357 22.8942 18.2124 22.9499C18.189 23.0057 18.1787 23.0659 18.1821 23.1262L18.3719 26.3175H17.6869L17.8528 23.1364C17.8559 23.0764 17.8452 23.0164 17.8217 22.961C17.7982 22.9055 17.7624 22.856 17.7169 22.816C17.6714 22.7761 17.6175 22.7467 17.559 22.7302C17.5005 22.7136 17.439 22.7102 17.379 22.7202L14.182 23.2587L14.6105 22.2459C14.6525 22.1481 14.6607 22.0394 14.6339 21.9365C14.6071 21.8336 14.5469 21.7423 14.4624 21.6766L11.0034 18.9686L11.7569 18.622C11.8248 18.5907 11.8787 18.536 11.9085 18.4681C11.9383 18.4002 11.9418 18.3238 11.9185 18.2535L11.2225 16.1536L13.1972 16.5631C13.2659 16.5773 13.3375 16.5677 13.3999 16.5358C13.4624 16.504 13.5118 16.4519 13.54 16.3883L13.9225 15.5298L15.514 17.2032C15.5571 17.2489 15.6141 17.2794 15.6764 17.2901C15.7387 17.3008 15.8028 17.2911 15.859 17.2625C15.9152 17.2339 15.9604 17.1879 15.9877 17.1315C16.015 17.0752 16.023 17.0116 16.0104 16.9503L15.2147 13.0396L16.3966 13.7989C16.4204 13.8142 16.4472 13.8244 16.4752 13.829C16.5033 13.8335 16.532 13.8322 16.5595 13.8252C16.587 13.8183 16.6127 13.8057 16.635 13.7883C16.6574 13.771 16.6758 13.7493 16.6892 13.7245L18.0236 11.2422L19.3267 13.7051C19.3396 13.7296 19.3574 13.7511 19.3791 13.7685C19.4007 13.7859 19.4256 13.7988 19.4525 13.8063C19.4793 13.8138 19.5073 13.8159 19.535 13.8123C19.5626 13.8088 19.5892 13.7997 19.6132 13.7856L20.8778 13.0421Z",
    fill: "#FF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0012 0C8.07542 0 0 7.98174 0 17.7924C0 21.0763 1.97769 26.3622 5.87615 33.5042C9.02601 39.2704 12.7298 44.9749 15.281 48.7459C15.5801 49.1877 15.9847 49.5499 16.4591 49.8004C16.9335 50.0509 17.4631 50.1819 18.0009 50.1819C18.5388 50.1819 19.0683 50.0509 19.5427 49.8004C20.0171 49.5499 20.4217 49.1877 20.7208 48.7459C23.2726 44.9761 26.9746 39.2716 30.1238 33.5054C34.0248 26.3634 36 21.0775 36 17.7936C36.0024 7.98174 27.927 0 18.0012 0ZM18.0012 31.4085C10.3928 31.4085 4.22531 25.3125 4.22531 17.7924C4.22531 10.2723 10.3928 4.1763 18.0012 4.1763C25.6096 4.1763 31.7735 10.2729 31.7735 17.7924C31.7735 25.3119 25.609 31.4085 18.0012 31.4085Z",
    fill: "url(#paint1_linear_589_5199)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0012 0.5C8.33926 0.5 0.506836 8.24397 0.506836 17.7914C0.506836 25.1724 10.9554 41.4469 15.7028 48.4648C15.9555 48.8382 16.2975 49.1442 16.6984 49.3559C17.0993 49.5675 17.5468 49.6782 18.0012 49.6782C18.4557 49.6782 18.9032 49.5675 19.3041 49.3559C19.705 49.1442 20.0469 48.8382 20.2997 48.4648C25.0471 41.4469 35.495 25.1724 35.495 17.7914C35.495 8.24155 27.6626 0.5 18.0012 0.5ZM18.0012 31.4075C10.3929 31.4075 4.22534 25.3116 4.22534 17.7914C4.22534 10.2713 10.3929 4.17536 18.0012 4.17536C25.6096 4.17536 31.7735 10.2719 31.7735 17.7914C31.7735 25.311 25.609 31.4075 18.0012 31.4075Z",
    fill: "url(#paint2_linear_589_5199)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_589_5199",
    x1: 3.5918,
    y1: 17.7945,
    x2: 32.4107,
    y2: 17.7945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CCCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#E4E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F8F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F2F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E1E0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C6C4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CECCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E5E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F2F0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BEBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_589_5199",
    x1: 34.1802,
    y1: 28.0616,
    x2: -0.998083,
    y2: 21.1434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CCCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#E4E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F8F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F2F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E1E0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C6C4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CECCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E5E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F2F0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BEBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_589_5199",
    x1: 5.12023,
    y1: 31.3138,
    x2: 35.6776,
    y2: 13.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CCCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#E4E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F8F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F2F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E1E0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C6C4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CECCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E5E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F2F0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BEBF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadaFlag);
export default __webpack_public_path__ + "static/media/Canada-flag.6834592575bffe99c381584c001ad83f.svg";
export { ForwardRef as ReactComponent };